<template>
  <div class="inline-block px-10 mb-8">
    <div class="rounded-lg bg-white overflow-hidden" :class="{ 'shadow': shadow }">
      <slot name="image"></slot>
    </div>
    <div class="text-center md:text-left text-lg font-base caption mt-2">{{ caption }}</div>
    <div class="text-center md:text-left text-lg font-bold">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    caption: String,
    label: String,
    shadow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.caption {
  color: #A7A7A7;
}
</style>